import * as React from 'react'
import { compose, pure } from 'recompose'

import { ChoiceStatus } from '../../../../commons/ChoiceStatus'
import { QuestionType } from '../../../../commons/EditorStatus'
import QuestionEntity from '../../../../commons/entity/QuestionEntity'
import { isImageQuestion } from '../../../../commons/utils'
import QuestionChoice from '..//QuestionChoice/QuestionChoice'
import * as styles from './QuestionChoiceSet.css'

interface QuestionChoiceSetProps {
  question: QuestionEntity
  answerCount?: { [key: string]: number }
  showAnswer: boolean
}

const QuestionChoiceSet: React.FunctionComponent<QuestionChoiceSetProps> = ({
  question,
  answerCount,
  showAnswer = false
}) => {
  let buttonClass = ''
  let containerClass = ''
  switch (question.question_type) {
    case QuestionType.FOURCHOICE.value:
    case QuestionType.REALTIME.value:
      if (isImageQuestion(question.choices)) {
        buttonClass = styles.buttonImage
        containerClass = styles.containerImage
      } else {
        buttonClass = styles.buttonText
        containerClass = styles.containerImage
      }
      break
    case QuestionType.TRUEFALSE.value:
      buttonClass = styles.buttonTruefalse
      containerClass = styles.containerTruefalse
  }

  const buttons = question.choices.map((choice, index) => {
    let choiceStatus = ChoiceStatus.NORMAL
    if (showAnswer) {
      const isAnswer = question.answer_choice_id === choice.id
      choiceStatus = isAnswer ? ChoiceStatus.CORRECT : ChoiceStatus.TRANSPARENT
    }

    let targetAnswerCount
    let totalAnswerCount
    if (answerCount) {
      targetAnswerCount = (answerCount && answerCount[choice.id]) || 0
      totalAnswerCount = 0
      for (const key in answerCount) {
        if (answerCount.hasOwnProperty(key)) {
          totalAnswerCount += answerCount[key] || 0
        }
      }
    }

    return (
      <div className={buttonClass} key={`choice-${choice.id}`}>
        <QuestionChoice
          index={index}
          type={question.question_type}
          src={choice.image}
          isMaru={choice.maru}
          answerCount={targetAnswerCount}
          totalAnswerCount={totalAnswerCount}
          choiceStatus={choiceStatus}
        >
          {choice.title}
        </QuestionChoice>
      </div>
    )
  })
  return <div className={containerClass}>{buttons}</div>
}

export default compose<QuestionChoiceSetProps, QuestionChoiceSetProps>(pure)(QuestionChoiceSet)
